/**
 * LoadingSpinner - Consistent loading state component
 *
 * Usage:
 *   <LoadingSpinner message="Loading pools..." />
 */
function LoadingSpinner({ message = 'Loading...', fullPage = false }) {
    const content = (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '16px',
            padding: fullPage ? '0' : '40px 20px',
        }}>
            <div style={{
                width: '40px',
                height: '40px',
                border: '3px solid rgba(255, 255, 255, 0.1)',
                borderTopColor: '#ffc107',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
            }} />
            <p style={{
                margin: 0,
                color: 'rgba(255, 255, 255, 0.6)',
                fontSize: '0.95rem',
            }}>
                {message}
            </p>
            <style>{`
                @keyframes spin {
                    to { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );

    if (fullPage) {
        return (
            <div style={{
                minHeight: '100vh',
                background: 'linear-gradient(180deg, #12121a 0%, #1a1a2e 50%, #12121a 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}>
                {content}
            </div>
        );
    }

    return content;
}

export default LoadingSpinner;
